import { httpClientRepository } from '@bg-shared/infrastructure';
import { IDropdownOption } from '@bg-shared/interfaces';
import { DealerLanguage, GameId } from '@bg-shared/enums';
import { sessionStore } from '@bg-shared/business/Session';
import { API_URLS } from '@bg-shared/constants';
import { IDealerLobbyResponse, IDealersData } from './interfaces';
import { dealerLobbyStore } from './DealerLobby.store';

export default class DealerLobbyService {
    private getOptions(data: IDealersData[]): IDropdownOption<DealerLanguage>[] {
        return data.map((item) => ({
            value: item.group as DealerLanguage,
            label: item.group ? (item.group as string) : 'all_languages',
        }));
    }

    // Todo: after BE part release and docs provided refactor to be reusable across different games?
    public async updateDealers(): Promise<{
        result: IDealersData[];
        defaultLanguage: DealerLanguage;
    }> {
        try {
            const response = await httpClientRepository.get<Record<GameId, IDealerLobbyResponse>>(
                `${API_URLS.VOD_INITIAL}/${sessionStore.partnerCode}`,
                {
                    transformResponse: false,
                },
            );
            const result = response?.[GameId.RNG_ROULETTE]?.dealers ?? [];

            dealerLobbyStore.update((draft) => {
                draft.dealers = result;
                draft.dealerOptions = this.getOptions(result);
                draft.defaultLanguage = response[GameId.RNG_ROULETTE]?.defaultLanguage;
            });

            return { result, defaultLanguage: response[GameId.RNG_ROULETTE]?.defaultLanguage };
        } catch {
            return { result: [], defaultLanguage: null };
        }
    }

    public areSavedSettingsCorrect(
        data: IDealersData[],
        selectedVOD: {
            dealer: string;
            language: DealerLanguage;
        },
    ): boolean {
        if (!data.length) {
            return false;
        }

        const group = data.find((item) => item.group === selectedVOD.language);
        // Invalid language saved
        if (!group) {
            return false;
        }
        // check if valid dealer for given language saved
        return group.options.some((option) => option.id === selectedVOD.dealer);
    }
}

export const dealerLobbyService = new DealerLobbyService();
